/* eslint-disable array-bracket-spacing */
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { skipToken } from "@reduxjs/toolkit/query";
import { useLocation, useNavigate } from "react-router-dom";

import { isValidAccountId } from "common/shared/utils/validation.utils";
import { FormHeader, NavigationButtons, Spinner } from "common/lib/components";
import { custodyAccountsApiReducer } from "domains/custodyAccounts/store/custodyAccounts.api.reducer";
import { documentsApiReducer } from "domains/documents/store/documents.api.reducer";
import RequiredDocumentsList from "domains/documents/components/RequiredDocumentsList";
import { CustodyAccountStatus } from "domains/custodyAccounts/shared/types";
import { useClientsSelector } from "domains/clients";
import { AccountType , URLs } from "common/lib/constants";
import { IDocument } from "domains/documents/shared/types";
import { useScreen } from "common/shared-hooks";
import { DocumentsUpload } from "v2/features/documents";
import { AltCustodyAssetPages } from "domains/altCustody/shared/constants";

import "./assetDocumentsUpload.scss";

const AssetPortfolioDocumentsUpload = () => {
  const { user } = useClientsSelector();
  const { pathname } = useLocation();
  const { isAdvisor } = useClientsSelector();
  const { data: custodyAccounts } = custodyAccountsApiReducer.useFetchCustodyAccountsQuery(
    user ? { accountId: user.account_id, userId: user.user_id } : skipToken,
  );

  const navigate = useNavigate()
  const [ isFirstTime, setIsFirstTime ] = useState(1); 
  const [ documentList, setDocumentList ] = useState<any>([]);
  const { data: documents = [] } = documentsApiReducer.useFetchDocumentsByIdQuery(
    isValidAccountId(user?.account_id) ? user!.account_id : skipToken,
    { skip: !isValidAccountId(user?.account_id) },
  );

  const activeCustodyAccounts = custodyAccounts?.filter(
    (custodyAccount) =>
      custodyAccount.account_status !== CustodyAccountStatus.Closed &&
      custodyAccount.account_status !== CustodyAccountStatus.ClosedForNewAccount &&
      custodyAccount.account_status !== CustodyAccountStatus.Duplicate &&
      custodyAccount.account_type !== AccountType.CustodialAdvisor,
  );


  const onUpload = async () => {
    // await dispatch(fetchLRDocuments())
  }

  const beforeUpload = async () => {
    if (!activeCustodyAccounts?.length && !isAdvisor) {
      const currentPath = location.pathname;
      const pathParts = currentPath.split('/');
      const newPath = `${ pathParts.join('/') }${ AltCustodyAssetPages.CustodyAccountAgreement }`;
      navigate(newPath, { state: { fromUpload: true } });
      return false;
    }
    return true
  }

  const onDelete = async () => {
    // await dispatch(fetchLRDocuments())
  }

  const documentProps = {
    document_type: "person_account",
    reference_type: "account",
    documentList,
    account_id: user?.account_id,
    setDocumentList,
    onUpload,
    onDelete,
    beforeUpload,
  }

  const onSkip = () => {
    navigate(URLs.PROTECTED.DASHBOARD)
  }

  useEffect(() => {
    if(pathname.includes('altquote')) {
      onSkip()
    }
  }, [ ]);

  useEffect(() => {
    const formattedDocuments = [...documents].map((doc) => ({
      doc,
      file: {},
      uploadStatus: "uploaded",
    }));
    const pendingList = documentList.filter(
      ({ uploadStatus }:any) => uploadStatus === "pending",
    );
    const documentMap = new Map();
    const generateKey = (doc:any) => `${ doc.file_name }`;
    formattedDocuments.forEach((doc) => {
      documentMap.set(generateKey(doc.doc), doc);
    });
    pendingList.forEach((pendingDoc:any) => {
      const key = generateKey(pendingDoc.doc);
      if (!documentMap.has(key)) {
        documentMap.set(key, pendingDoc);
      }
    });
    const mergedList = Array.from(documentMap.values());
    const filteredList = mergedList.filter(({ doc }:any) => doc.document_type !== 'proposal' && doc.document_type !== 'proposal_json' && doc.document_type !== 'term_sheet' )
    setDocumentList(filteredList);
  }, [documents]);
  
  
  // if (isLoading) {
  //   return <Spinner />;
  // }
  
  return (
    <>
        <div className="ben-upload-documents-form">
          <RequiredDocumentsList isCollapseActiveByDefault={ false } />
          <DocumentsUpload documentProps={ documentProps } />
        </div>
    </>
  );
};

export default AssetPortfolioDocumentsUpload;
